import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
import Button from './Button';
import styles from './InfiniteScrollWaypoint.module.scss';
import LoadingIndicator from './LoadingIndicator';

export type FetchMoreHandler = () => unknown | Promise<unknown>;

interface InfiniteScrollWaypointProps {
  fetchMore?: FetchMoreHandler | null;
  maxConsecutivePage?: number;
}

const InfiniteScrollWaypoint = ({
  fetchMore,
  maxConsecutivePage = 10,
}: InfiniteScrollWaypointProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [consecutivePageLoaded, setConsecutivePageLoaded] = useState(0);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [stopLoading, setStopLoading] = useState(false);

  const handleEnter = ({ currentPosition }: Waypoint.CallbackArgs) => {
    if (
      fetchMore &&
      !isLoading &&
      !stopLoading &&
      currentPosition === 'inside'
    ) {
      const promise = Promise.resolve(fetchMore());
      setConsecutivePageLoaded((p) => p + 1);

      promise
        .catch(() => setStopLoading(true))
        .finally(() => setIsLoading(false));
      setIsLoading(true);
    }
  };

  if (!fetchMore || stopLoading) return null;

  return consecutivePageLoaded < maxConsecutivePage ? (
    <>
      {isLoading ? (
        <div className={styles.loader}>
          <LoadingIndicator delay={0} />
        </div>
      ) : (
        <Waypoint onEnter={handleEnter} />
      )}
    </>
  ) : (
    <div className={styles.loader}>
      <Button block variant="link" onClick={() => setConsecutivePageLoaded(0)}>
        Load more
      </Button>
    </div>
  );
};

export default InfiniteScrollWaypoint;
